import type { ReactNode } from 'react';
import Dismiss from '../../../../../ui/Dismiss/Dismiss';
import styles from '../Fetch.module.css';

interface FetchModalProps {
  children: ReactNode;
  onClose: () => void;
  onBackdropClick: () => void;
}

export function FetchModal({
  children,
  onClose,
  onBackdropClick,
}: FetchModalProps) {
  return (
    <div
      className={styles.overlay}
      onClick={onBackdropClick}
      role="presentation"
    >
      <div
        className={styles.modal}
        onClick={(e) => e.stopPropagation()}
        role="dialog"
      >
        <div className={styles.closeBtn}>
          <Dismiss onClick={onClose} />
        </div>
        {children}
      </div>
    </div>
  );
}
